import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { Button } from "../../../Button";
import style from "./styles.pcss";
var cn = classNames.bind(style);
export var ButtonLink = /*#__PURE__*/memo(function (_ref) {
  var text = _ref.text,
    onClick = _ref.onClick,
    href = _ref.href,
    target = _ref.target;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('wrapper')
  }, href ?
  /*#__PURE__*/
  // toDo: заменить на Link после доработок по типографике
  React.createElement("a", {
    className: cn('button-link'),
    href: href,
    onClick: onClick,
    target: target
  }, text) : /*#__PURE__*/React.createElement(Button, {
    onClick: onClick,
    size: "s",
    textColor: "white",
    variant: "plain"
  }, text));
});